import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import ConfirmationDialogComponent from '@office-start/confirmation-dialog-component';
import OfficeFluentProvider from '@office-start/office-fluent-provider';
import * as React from 'react';
import { initializeFluentIcons } from '../shared/office-start/initialize-fluent-icons';

import { bootstrapOfficeStartComponent } from '../shared/office-start/bootstrap-office-start-component';
import { OfficeStartBootstrapperService } from '../shared/office-start/office-start-bootstrapper.service';
import ReactRenderer from '../shared/react/react-renderer';
import { ThemingService } from '../shared/services/theming.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { ContextService } from '../shared/shared-context/context.service';

@Directive({ selector: 'ohp-confirmation-dialog-react-content' })
export class ConfirmationDialogReactContentDirective extends ReactRenderer implements OnInit, OnDestroy {

    constructor(
        elementRef: ElementRef,
        capabilitiesService: CapabilitiesService,
        clientStartupConfigService: ClientStartupConfigService,
        contextService: ContextService,
        officeStartBootstrapperService: OfficeStartBootstrapperService,
        themingService: ThemingService
    ) {
        super(elementRef);
        bootstrapOfficeStartComponent(officeStartBootstrapperService, themingService);
        initializeFluentIcons(capabilitiesService, contextService, clientStartupConfigService);
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    public async getReactElement() {
        return (
            <OfficeFluentProvider>
                <ConfirmationDialogComponent/>
            </OfficeFluentProvider>
        );
    }
}
